var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaffeineAnxiety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F61;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#925F36;}\n\t.st3{fill:none;stroke:#422918;stroke-width:1.524;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.3,89.6l-2.7,0.8l-0.3,11.9l1.4,0.8c0,0,2.8,1.9,3.7-3.1c0.3-1.9,2.8-4.1,4.1-4.9c3.2-1.8,9,0.4,9,5.1 c0,2.6-0.5,5-1.7,7.2c-4.2,7.8-13.7,10-20.7,11.1c3.7-8.6,6.8-19.9,5.5-32.1h-1c0.8-0.4,1.3-0.8,1.3-1.3c0-2.7-16.1-4.8-35.9-4.8 c-19.8,0-35.9,2.1-35.9,4.8c0,0.4,0.5,0.9,1.3,1.3h-1.2c0,0-3.1,28.2,16.1,49.9c0,0,19,8,39.9-0.9c0,0,1.9-2.4,4.4-6.5 c1.3-0.5,3.4-1.4,6.9-3.3c0,0,23.1-8,25.1-18.1C158.7,107.6,165.3,83.4,139.3,89.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "137.8,90.7 136.5,90.6 136.5,85.2 137.9,85.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66,90.8 67.5,90.5 67.5,85.1 66.1,85.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,109.3c0,0,3.3,9.9,7.1,16.6c3.6,6.4,3.9,6.1,3.9,6.1s5.8,2.9,14.3,3.3s19.3-2.7,19.3-2.7 s6.5-9.2,8.9-15.5c2.2-5.7,2.4-8,2.4-8s-8.2-2.6-27.3-2.9S73.5,109.3,73.5,109.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.1,110.8c16,4.1,32.8,4.1,48.8,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeineAnxiety);
export default __webpack_public_path__ + "static/media/Caffeine_Anxiety.a788cfd7486ab802647058399828c6dc.svg";
export { ForwardRef as ReactComponent };